import { render, staticRenderFns } from "./SatusehatKyc.vue?vue&type=template&id=1c2c24c4&scoped=true&"
import script from "./SatusehatKyc.vue?vue&type=script&lang=js&"
export * from "./SatusehatKyc.vue?vue&type=script&lang=js&"
import style0 from "./SatusehatKyc.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SatusehatKyc.vue?vue&type=style&index=1&id=1c2c24c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c24c4",
  null
  
)

export default component.exports